const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = atob(base64)
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)))
}

/** Returns { ok, reason } */
export async function registerAdminPush(token) {
  if (!window.isSecureContext) {
    return { ok: false, reason: 'https-required' }
  }
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return { ok: false, reason: 'unsupported' }
  }

  try {
    // 1. Get VAPID public key
    const keyRes = await fetch(`${API_BASE_URL}/bookings/push/vapid-public-key`)
    const keyJson = await keyRes.json().catch(() => ({}))
    const publicKey = keyJson.publicKey
    if (!publicKey) return { ok: false, reason: 'no-vapid-key' }

    // 2. Register service worker
    const reg = await navigator.serviceWorker.register('/sw-push.js', { scope: '/' })
    await navigator.serviceWorker.ready

    // 3. Check existing subscription
    let sub = await reg.pushManager.getSubscription()

    // 4. If not subscribed, request permission then subscribe
    if (!sub) {
      const permission = await Notification.requestPermission()
      if (permission === 'denied') return { ok: false, reason: 'permission-denied' }
      if (permission !== 'granted') return { ok: false, reason: 'permission-dismissed' }
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
      })
    }

    // 5. Send subscription to server
    const subRes = await fetch(`${API_BASE_URL}/bookings/push/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(sub.toJSON())
    })
    if (!subRes.ok) {
      const json = await subRes.json().catch(() => ({}))
      throw new Error(json.message || `Server rejected subscription (${subRes.status})`)
    }

    return { ok: true }
  } catch (err) {
    console.warn('[push] registration failed:', err.message)
    return { ok: false, reason: 'error', message: err.message }
  }
}

/** Returns true if push could ever work in this browser/context */
export function isPushAvailable() {
  return window.isSecureContext && 'serviceWorker' in navigator && 'PushManager' in window
}
